import {
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
} from "@microsoft/signalr";
// import BASE_URL from "../config/baseUrl";

const newHubConnection = (slug: string): HubConnection => {
  const domain =
    process.env.REACT_APP_NOTIFICATIONS_URL ?? "https://localhost:5004";
  const url = `${domain}/${slug}`;
  const connection = new HubConnectionBuilder()
    .withUrl(url)
    .withAutomaticReconnect()
    .build();

  // eslint-disable-next-line no-console
  console.log("Notification connection id: ", connection);

  connection.serverTimeoutInMilliseconds = 900000;

  return connection;
};

// eslint-disable-next-line import/prefer-default-export
export const notificationsConnection = newHubConnection("notificationHub");

// POZOR: Pokud dispatchuju middleware akci, je potřeba, aby action marametr
// obsahoval halt na duplicitní resuesty. Jinak se může stát, že:
// 1. Hub je disconnected
// 2. První průchod zavolá start()
// 3. Ještě než se hub nastartuje a .then(action) má šanci nastavit isFetching
//    na true, tak se runSignalrAction zavolá mnohokrát znovu
// 4. Jelikož hub je Connecting, tak se queunou callbacky
//    (přes setTimeout, bo SignalR FE je mrdka)
// 5. Po připojení se triggernou všechny requesty
//    (první sice nastaví isFetching na true, ale ostatní už jsou ve frontě)
export const runSignalrAction = (
  connection: HubConnection,
  action: (connectionId?: string | null) => void
): void => {
  switch (connection.state) {
    case HubConnectionState.Connected:
      action();
      break;

    case HubConnectionState.Disconnected:
      connection.start().then(() => action(connection.connectionId));
      break;

    case HubConnectionState.Reconnecting:
      connection.onreconnected(action);
      break;

    case HubConnectionState.Disconnecting:
      connection.onclose(() => {
        connection.start().then(() => action());
      });
      break;

    case HubConnectionState.Connecting:
      // Zkurevená mrdka npm SignalR, imo to líp nejde, bo Microsoftu nepříšlo
      // jako důležitý dát sem na to callback ...
      // https://stackoverflow.com/questions/66654124/how-to-append-a-post-connect-callback-to-an-already-connecting-signalr-hubconnec
      setTimeout(() => runSignalrAction(connection, action), 250);
      break;

    default:
  }
};
